/**
 * Source: docs/rules/06-reputation.md, "RECOMMENDED RENOWN".
 *
 * A suggestion, not a rule -- a captain may start with any Renown, or none.
 * Keyed on Cost, which is why this sits in the Leviathan package while the
 * tier and path tables are shared from @personnel/setting.
 *
 * Note the ceiling: the most expensive captain is only recommended 21 Renown,
 * which is Tier 3. Tier 4 and above are earned in play, never suggested here.
 */

interface RecommendedBand {
  /** Lowest Cost in the band. */
  readonly cost: number;
  readonly renown: number;
}

/** Highest Cost first, so the first match wins. */
const RECOMMENDED_RENOWN: readonly RecommendedBand[] = [
  { cost: 55, renown: 21 },
  { cost: 26, renown: 11 },
  { cost: 0, renown: 0 },
];

export function recommendedRenownFor(cost: number): number {
  return RECOMMENDED_RENOWN.find((band) => cost >= band.cost)?.renown ?? 0;
}
